module.exports = __webpack_public_path__ + "img/46.e8e126b6.jpg";